import type { LineChartReportCardProps } from '../../AnalyticsDashboard.types'
import { useLineChartReportCard } from '../useLineChartReportCard'

const reportId = 'total_profit'

type Options = {
  type: 'total' | 'shop' | 'memberships'
  headerLabel?: string
  headerTooltipTitle?: string
  headerTooltipDescription?: string
}

const filters: Record<Options['type'], Record<string, string>> = {
  total: {},
  shop: {
    shop_metrics: 'orders,donations,giveaway_links,manual_charges',
    shop_and_memberships_metrics: 'twitch_gifts',
  },
  memberships: {
    membership_metrics:
      'memberships_subscriptions,memberships_message_tips,memberships_locked_messages,memberships_subscription_gifts',
    shop_and_memberships_metrics: 'twitch_gifts',
  },
}

const headerLabelMap: Record<Options['type'], string> = {
  total: 'Total profit',
  shop: 'Shop profit',
  memberships: 'Memberships profit',
}

const headerTooltipTitleMap: Record<Options['type'], string> = {
  total: 'Total profit',
  shop: 'Shop profit',
  memberships: 'Memberships profit',
}

const headerTooltipDescriptionMap: Record<Options['type'], string> = {
  total: 'Total amount earned from all sales.',
  shop: 'Total amount earned from shop orders, donations, giveaways and gifts.',
  memberships:
    'Total amount earned from new subscriptions, renewals, upgrades, tips, locked DMs, gifted subscriptions, and Twitch gifts.',
}

export const useTotalProfitReportCard = ({
  type,
  headerLabel,
}: Options): LineChartReportCardProps => {
  return useLineChartReportCard({
    reportId,
    headerLabel: headerLabel ?? headerLabelMap[type],
    headerTooltipTitle: headerTooltipTitleMap[type],
    headerTooltipDescription: headerTooltipDescriptionMap[type],
    headerTooltipFormula: 'Profit = Gross sales - Discounts - Costs - Refunds - Cancels',
    filters: filters[type],
  })
}
